import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldBreak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShieldBreak"><Path d="M18.8887 18.7921L22.1555 21.4055L23.4049 19.8438L1.84314 2.59439L0.59375 4.15613L3 6.08113V13C3 17.9705 7.02944 22 12 22C14.7644 22 17.2378 20.7536 18.8887 18.7921Z" fill="currentColor"/><Path d="M21 13C21 13.7409 20.9105 14.461 20.7416 15.1499L6.54694 3.79416L12 1.40845L21 5.34595V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldBreak;
